module.exports = __webpack_public_path__ + "img/logo-shop.52ef78ac.png";